import './App.css'
import 'bootstrap/dist/js/bootstrap.bundle';
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import Index from './Component/Index/Index';
import About from './Component/About/About';
import Contact from './Component/Contact/Contact';
import AllProduct from './Component/AllProduct/AllProduct';
import Login from './Component/Authentication/Login/Login';
import SignUp from './Component/Authentication/SignUp/SignUP';
import ForgetPassword from './Component/Authentication/ForgetPassword/ForgetPassword';
import AllBlog from './Component/AllBlog/AllBlog';
import SingleBlog from './Component/SingleBlog/SingleBlog';
import Cart from './Component/Cart/Cart';
import Wishlist from './Component/Wishlist/Wishlist';
import Checkout from './Component/Checkout/Checkout';
import SingleProduct from './Component/SingleProduct/SingleProduct';
import Artist from './Component/Artist/Artist';
import SingleArtist from './Component/SingleArtist/SingleArtist';
import MyProfile from './Component/MyProfile/MyProfile';
import ProfileInfo from './Component/MyProfile/ProfileInfo/ProfileInfo';
import ThisWeek from './Component/ThisWeek/ThisWeek';
import ImageUpload from './Component/MyProfile/ImageUpload/ImageUpload';
import EditProfile from './Component/MyProfile/EditProfile/EditProfile';
import ChangeInfo from './Component/MyProfile/ChangeInfo/ChangeInfo';
import MyOrderEmpty from './Component/MyProfile/MyOrderEmpty/MyOrderEmpty';
import EmptyMessage from './Component/MyProfile/EmptyMessage/EmptyMessage';
import EmptyNotification from './Component/MyProfile/EmptyNotification/EmptyNotification';
import Features from './Component/Features/Features';
import MyOrder from './Component/MyProfile/MyOrder/MyOrder';
import Notification from './Component/MyProfile/Notification/Notification';
import ScrollToTop from './Component/ScrollToTop/ScrollToTop';


function App() {
  return (
    <div>
      <BrowserRouter>
      <ScrollToTop/>
      <Routes>
        
        <Route path="/" element={<Navigate to ="/index"/>} />
        <Route path="/index" element={<Index/>} />
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/allProduct" element={<AllProduct/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/signup" element={<SignUp/>}/>
        <Route path="/forgetPassword" element={<ForgetPassword/>}/>
        <Route path="/allblog" element={<AllBlog/>}/>
        <Route path="/cart/:productId" element={<Cart/>}/>
        <Route path="/cart" element={<Cart/>}/>
        <Route path="/wishlist" element={<Wishlist/>}/>
        <Route path="/checkout" element={<Checkout/>}/>
        <Route path="/singleblog" element={<SingleBlog/>}/>
        <Route path="/singleproduct/:productId" element={<SingleProduct/>}/>
        <Route path="/artist" element={<Artist/>}/>
        <Route path="/sartist/:artistId" element={<SingleArtist/>}/>
        
        <Route path="myprofile" element={<MyProfile/>}>
          <Route path='profile' element={<ProfileInfo/>}/>
          <Route path='myorderempty' element={<MyOrderEmpty/>}/>
          <Route path='myorder' element={<MyOrder/>}/>
          <Route path='profileImg' element={<ImageUpload/>}/>
          <Route path='profile/editprofile' element={<EditProfile/>}/>
          <Route path='profile/changeinfo' element={<ChangeInfo/>}/>
          <Route path='emptymessage' element={<EmptyMessage/>}/>
          <Route path='notification' element={<Notification/>}/>
          <Route path='emptynotification' element={<EmptyNotification/>}/>
        </Route>

          <Route path="/" element={<Navigate to="/index" />} />
          <Route path="/index" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/allProduct" element={<AllProduct />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgetPassword" element={<ForgetPassword />} />
          <Route path="/allblog" element={<AllBlog />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/singleblog" element={<SingleBlog />} />
          <Route path="/singleproduct" element={<SingleProduct />} />
          <Route path="/artist" element={<Artist />} />
          <Route path="/sartist" element={<SingleArtist />} />

          <Route path="myprofile" element={<MyProfile />}>
            <Route
              path="/myprofile"
              element={<Navigate to="profile" />}
            />
            <Route path='profile' element={<ProfileInfo />} />
            <Route path='myorderempty' element={<MyOrderEmpty />} />
            <Route path='myorder' element={<MyOrder />} />
            <Route path='profileImg' element={<ImageUpload />} />
            <Route path='profile/editprofile' element={<EditProfile />} />
            <Route path='profile/changeinfo' element={<ChangeInfo />} />
            <Route path='emptymessage' element={<EmptyMessage />} />
            <Route path='notification' element={<Notification />} />
            <Route path='emptynotification' element={<EmptyNotification />} />
          </Route>

          <Route path="/thisweek" element={<ThisWeek />} />
          <Route path="/feature" element={<Features />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
